export default "__VITE_ASSET__Bg6CRcl2__"